import chartTypes from "../types/chart";

export const initialState = {
  isauthLoading: false,
  radarChartData: null,
  radarChartDataSuccess: null,
  radarChartDataFailure: null,
};

function chart(state = initialState, action) {
  switch (action.type) {
    case chartTypes.RADAR_CHART_DATA:
      return {
        ...state,
        isauthLoading: false,
        radarChartData: action.payload,
      };

    case chartTypes.RADAR_CHART_DATA_SUCCESS:
      return {
        ...state,
        isauthLoading: false,
        radarChartDataSuccess: action.payload,
      };

    case chartTypes.RADAR_CHART_DATA_FAILURE:
      return {
        ...state,
        isauthLoading: false,
        radarChartDataFailure: action.payload,
      };

    default:
      return { ...state };
  }
}

export default chart;
